module.exports = __webpack_public_path__ + "img/book_web.341cf97f.png";